import { useState, type FormEvent } from 'react'
import { Link } from '@tanstack/react-router'
import { Logo } from '@/components/Logo'
import { useRequestPasswordReset } from '@/lib/queries'

/**
 * Self-service half of the password-reset flow — the other half is an admin
 * clicking "Resend invite" on the Users screen. Both send the same email.
 */
export function ForgotPassword() {
  const [email, setEmail] = useState('')
  const requestReset = useRequestPasswordReset()

  function onSubmit(event: FormEvent) {
    event.preventDefault()
    requestReset.mutate(email)
  }

  return (
    <div className="auth-split">
      <div className="auth-brand">
        <Logo layout="stacked" theme="white" size={52} />
      </div>

      <div className="auth-form-side">
        <form className="auth-form" onSubmit={onSubmit}>
          <h1>Forgot password</h1>

          {requestReset.isSuccess ? (
            <p>If that address is registered, a reset link is on its way. Check your inbox.</p>
          ) : (
            <>
              <p className="social-hint" style={{ marginBottom: 'var(--space-4)' }}>
                Enter your email and we&rsquo;ll send you a link to set a new password.
              </p>

              <div className="field">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  className="input"
                  type="email"
                  autoComplete="username"
                  required
                  placeholder="you@madstheatre.org"
                  style={{ minHeight: 46 }}
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-block"
                style={{ minHeight: 48 }}
                disabled={requestReset.isPending}
              >
                {requestReset.isPending ? 'Sending…' : 'Send reset link'}
              </button>
            </>
          )}

          <p className="social-hint">
            <Link to="/sign-in">Back to sign in</Link>
          </p>
        </form>
      </div>
    </div>
  )
}
